import axios from 'axios';

export const HTTP = axios.create({

    baseURL: process.env.VUE_APP_ROOT_API, //http://vvg.salesintranet.com/api/v1
    headers: {
      'Content-Type': 'application/json',
    }
});
export const HTTPGUZZLE = axios.create({

    // baseURL: "https://www.velocitytruckcenters.com",
    // baseURL: "http://velocitytruckcenters.local.com",
    baseURL: process.env.VUE_APP_SSO_URL,
    headers: {
      'Content-Type': 'application/json',
    }
});
HTTPGUZZLE.interceptors.response.use(function (response) {
  // We have removed Wilmington, NC location requested by April Sheppard and We have added branch wise Wilmington location added in VTC Website.
  if(response.data.locations && response.data.locations.length > 0) {
    for(var index = 0; index < response.data.locations.length; index++) {
      var objLocation = response.data.locations[index];
      if(objLocation['name'] == 'Wilmington, NC' || objLocation['id'] == 32) {
        response.data.locations.splice(index, 1);
      }

      if(objLocation['name'] == 'Whittier, CA' || objLocation['id'] == 11) {
        response.data.locations.splice(index, 1);
      }
    }
    var objWilmington372 = {
      "name": "Wilmington 372, NC",
      "id": 9993,
      "position": {
        "lat": 34.225727,
        "lng": -77.944710
      },
      "is_buswest": false,
      "manager_email": "dbrant@vvgtruck.com",
      "manager_name": "Taylor McKoy",
      "branch_code": "372"
    };
    // response.data.locations.push(objWilmington372);
    var objWilmington373 = {
      "name": "Wilmington 373, NC",
      "id": 9994,
      "position": {
        "lat": 34.225727,
        "lng": -77.944710
      },
      "is_buswest": false,
      "manager_email": "dbrant@vvgtruck.com",
      "manager_name": "Deanne Brant",
      "branch_code": "373"
    };
    // response.data.locations.push(objWilmington373);
  }
  return response;
});